const BASE = '/api/auth';

/** Há sessão válida? (cookie HttpOnly — o JS não lê o cookie, então pergunta ao backend.) */
export async function checarSessao(): Promise<boolean> {
  try {
    const r = await fetch(`${BASE}/me`, { headers: { 'Content-Type': 'application/json' } });
    if (!r.ok) return false;
    const b = (await r.json()) as { autenticado?: boolean };
    return !!b?.autenticado;
  } catch {
    return false;
  }
}

/** Faz login. Lança Error com a mensagem do backend se a senha estiver errada. */
export async function entrar(senha: string): Promise<void> {
  const r = await fetch(`${BASE}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ senha }),
  });
  const b = (await r.json().catch(() => ({}))) as { erro?: string };
  if (!r.ok) throw new Error(b?.erro || `HTTP ${r.status}`);
}

/** Encerra a sessão (limpa o cookie no servidor). */
export async function sair(): Promise<void> {
  await fetch(`${BASE}/logout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).catch(() => {});
}
